import { Component } from "@angular/core";
import { NavParams } from "ionic-angular";
import { Subscription } from "rxjs";
import { Train } from "../../models";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";

/**
 * Generated class for the TrainStatusComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "train-status",
  templateUrl: "train-status.html",
})
export class TrainStatusComponent {
  constructor(private starms: StarmsClientProvider, public nav: NavParams) {}
}



// WEBPACK FOOTER //
// ./src/components/train-status/train-status.ts